import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import PopupLink from '@/components/Cluster/PopupLink';

export default function Body({
  username,
  createTime,
  operateDesc,
  resourceType,
  resourceName,
  type,
}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const clusterName = searchParams.get('name');

  const linkTo = () => {
    const prefix = type === 'pulsar' ? '/cluster' : '/kop-cluster';
    switch (resourceType) {
      case 'topic':
        navigate(`${prefix}/topic/list?name=${clusterName}&topic=${resourceName}`);
        break;
      case 'namespace':
        navigate(`${prefix}/namespace/list?name=${clusterName}&namespace=${resourceName}`);
        break;
      case 'tenant':
        navigate(`${prefix}/tenant/list?name=${clusterName}&tenant=${resourceName}`);
        break;
      case 'role':
        if (type === 'pulsar') {
          navigate(`${prefix}/permissions/roles?name=${clusterName}&roleName=${resourceName}`);
        } else {
          navigate(`${prefix}/permissions/users?name=${clusterName}&kafkaUser=${resourceName}`);
        }
        break;
      case 'permission':
        if (type === 'pulsar') {
          navigate(`${prefix}/permissions/grant?name=${clusterName}&roleName=${resourceName}`);
        } else {
          navigate(`${prefix}/permissions/grant?name=${clusterName}&roleName=${resourceName}`);
        }
        break;
      case 'cluster':
        navigate(`${prefix}/broker/list?name=${clusterName}`);
        break;
      default:
        break;
    }
  };
  return (
    <Root>
      <li>
        <Title>用户</Title>
        <Info>{username}</Info>
      </li>
      <li>
        <Title>资源</Title>

        <LinkInfo onClick={linkTo} tip='点击跳转'>
          {resourceName}
        </LinkInfo>
      </li>
      <li>
        <Title>时间</Title>
        <Info>{createTime}</Info>
      </li>
      <li>
        <Title>内容</Title>
        <Info>{operateDesc}</Info>
      </li>
      <li>
        <Title>类型</Title>
        <Info>{resourceType}</Info>
      </li>
    </Root>
  );
}

const Root = styled.ul`
  border-radius: 4px;
  background: rgb(250, 250, 250);
  margin-top: 10px;
  padding: 8px 16px;

  li {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    .icon-container {
      padding: 0;
    }
  }
  li:last-child {
    border-bottom: none;
  }
`;

const Title = styled.div`
  width: 24px;
  margin-right: 16px;
  color: rgb(143, 149, 159);
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
`;

const Info = styled.div`
  flex: 1;
  width: 0;
  color: rgb(32, 43, 64);
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  word-break: break-all;
`;

const LinkInfo = styled(PopupLink)`
  flex: 1;
  width: 0;
  word-break: break-all;
  &&& {
    font-size: 12px;
    line-height: 17px;
  }
`;
